import { ErrorPage } from '../../../components/ErrorPage/ErrorPage.js';

export const ErrorPath = () => {
  return <ErrorPage />;
};
